import { render, staticRenderFns } from "./SearchWidget.vue?vue&type=template&id=687e88d8&scoped=true&"
import script from "./SearchWidget.vue?vue&type=script&lang=js&"
export * from "./SearchWidget.vue?vue&type=script&lang=js&"
import style0 from "./SearchWidget.vue?vue&type=style&index=0&id=687e88d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e88d8",
  null
  
)

export default component.exports